import Barba from 'barba.js';
import * as ViewHome from './home.js';
import * as ViewEvent from './event.js';
import * as ViewService from './service.js';
import * as ViewKategorienUebersicht from './kategorien-uebersicht.js';

export default class Views {
	getAllViews(){
		return [
			ViewHome,
			ViewEvent,
			ViewService,
			ViewKategorienUebersicht
		];
	}
}
